var _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGuardarianHorizontal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 24,
    viewBox: "0 0 216 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3398 9.64551C20.8099 11.6075 16.5047 15.4001 17.4721 13.8337H8.30178C7.30968 12.5364 6.62771 11.1176 6.2998 9.64551H19.3398Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.682 20.9506C15.3788 21.9896 13.9699 22.8885 12.4785 23.6326L11.7491 24L11.0153 23.6341C4.11605 20.1719 0 14.2084 0 7.67309V0H4.2079V7.67309C4.20715 8.16251 4.24015 8.65141 4.30667 9.1363C4.83654 13.1067 7.51654 16.7694 11.7333 19.2356C11.7373 19.2393 11.7418 19.2425 11.7467 19.2449C11.7511 19.2425 11.7536 19.24 11.758 19.238L11.7758 19.2267C13.2999 20.0791 14.9596 20.6623 16.682 20.9506Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3679 9.64551C23.1732 11.1621 22.7572 12.6421 22.1334 14.0381C20.9798 16.6302 19.126 18.9892 16.684 20.9517C14.9625 20.6631 13.3036 20.0799 11.7803 19.2277C12.3306 18.9033 12.8641 18.5513 13.3788 18.1729C13.4301 18.1397 13.4795 18.1038 13.5269 18.0653C16.3773 16.0127 18.4308 13.0383 19.3398 9.64551H23.3679Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4983 0.00170898H4.20789V4.20764H23.4983V0.00170898Z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4983 4.20752V7.6732C23.4983 7.81641 23.4939 7.96011 23.4894 8.10381H19.2791C19.2833 7.95995 19.2855 7.81641 19.2855 7.6732V4.20752H23.4983Z",
    fill: "url(#paint4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8079 11.2794C66.8079 12.7054 66.6474 13.8697 66.3263 14.7723C65.8922 16.0685 65.0375 17.1825 63.8978 17.9373C62.7435 18.664 61.4 19.033 60.0365 18.9977C57.6174 18.9977 55.7617 18.1747 54.4692 16.5288C53.4818 15.2519 52.9637 13.6742 53.002 12.0606C53.002 10.1435 53.5747 8.53197 54.7201 7.22603C56.0194 5.74201 57.834 5 60.164 5C61.7196 5 63.0384 5.39935 64.1204 6.19802C64.8921 6.76194 65.5512 7.59771 66.0976 8.70533L62.8596 10.047C62.6441 9.52001 62.3136 9.0478 61.8923 8.66486C61.3609 8.22895 60.6913 7.99713 60.0041 8.01121C58.5133 8.01121 57.4744 8.77818 56.8876 10.3121C56.6685 10.8704 56.5566 11.4649 56.5577 12.0646C56.5398 12.6399 56.6359 13.213 56.8405 13.751C57.045 14.289 57.354 14.7812 57.7497 15.1993C58.3379 15.8226 59.1224 16.1335 60.1033 16.1322C60.9735 16.1322 61.6636 15.8792 62.1736 15.3733C62.5461 14.9635 62.7773 14.445 62.8333 13.894H60.0142V11.2794H66.8079ZM84.4266 13.0157C84.4349 13.6957 84.367 14.3745 84.2242 15.0394C84.0024 15.9594 83.5079 16.791 82.8056 17.4253C81.737 18.4358 80.3083 18.941 78.5193 18.941C76.6993 18.941 75.2779 18.4263 74.2553 17.397C73.7027 16.8349 73.318 16.1299 73.1443 15.3612C72.9841 14.5934 72.9128 13.8099 72.9318 13.0259V5.42093H76.3579V12.5462C76.3579 13.1196 76.3681 13.5466 76.3883 13.8272C76.4504 14.7217 76.8551 15.3456 77.6026 15.6991C77.9229 15.8489 78.273 15.9244 78.6266 15.9197C79.4617 15.9197 80.0917 15.6276 80.5167 15.0434C80.8324 14.6131 80.9903 13.7807 80.9903 12.5462V5.42093H84.4165L84.4266 13.0157ZM102.47 18.593H98.8113L97.9634 16.2961H93.2339L92.3273 18.593H88.7088L93.7682 5.42093H97.5101L102.47 18.593ZM97.0365 13.6916L95.6199 9.49253L94.181 13.6916H97.0365ZM118.893 18.593H114.643L111.371 13.5338V18.593H107.936V5.42093H113.265C114.822 5.42093 115.973 5.88705 116.719 6.81928C117.324 7.57065 117.644 8.5104 117.626 9.47433C117.626 10.6386 117.279 11.5681 116.584 12.2629C116.074 12.7414 115.438 13.0631 114.75 13.1898L118.893 18.593ZM114.076 9.66253C114.08 9.44012 114.037 9.21946 113.948 9.0153C113.86 8.81114 113.729 8.62818 113.564 8.47868C113.241 8.17648 112.721 8.02605 112.004 8.0274H111.365V11.3078H112.004C112.729 11.3078 113.247 11.156 113.564 10.8545C113.729 10.703 113.859 10.5185 113.947 10.313C114.035 10.1076 114.078 9.88593 114.074 9.66253H114.076ZM135.834 12.0019C135.815 13.365 135.383 14.6905 134.595 15.8032C133.808 16.916 132.701 17.7638 131.422 18.2348C130.752 18.4698 130.047 18.5903 129.337 18.5909H124.278V5.42093H129.337C130.561 5.41619 131.759 5.77544 132.778 6.453C133.801 7.11024 134.624 8.03558 135.158 9.12828C135.6 10.0216 135.832 11.0049 135.834 12.0019ZM132.282 12.0019C132.299 11.1455 132.03 10.308 131.517 9.62205C130.842 8.72489 129.831 8.27699 128.481 8.27834H127.698V15.7376H128.481C129.831 15.7376 130.842 15.289 131.517 14.3918C132.028 13.7012 132.295 12.8607 132.278 12.0019H132.282ZM152.902 18.593H149.245L148.395 16.2961H143.665L142.759 18.593H139.14L144.2 5.42093H147.942L152.902 18.593ZM147.468 13.6916L146.051 9.49253L144.623 13.6916H147.468ZM169.324 18.593H165.062L161.792 13.5338V18.593H158.37V5.42093H163.696C165.253 5.42093 166.405 5.88705 167.151 6.81928C167.755 7.57065 168.076 8.5104 168.058 9.47433C168.058 10.6386 167.71 11.5681 167.015 12.2629C166.506 12.7414 165.869 13.0631 165.182 13.1898L169.324 18.593ZM164.51 9.66253C164.513 9.43999 164.469 9.21928 164.381 9.01513C164.292 8.81097 164.161 8.62808 163.996 8.47868C163.672 8.17715 163.154 8.0274 162.438 8.0274H161.798V11.3078H162.432C163.155 11.3078 163.674 11.1567 163.99 10.8545C164.156 10.7036 164.287 10.5194 164.377 10.314C164.466 10.1085 164.511 9.88652 164.508 9.66253H164.51ZM178.142 18.593H174.714V5.42093H178.14L178.142 18.593ZM197.38 18.593H193.721L192.871 16.2961H188.143L187.237 18.593H183.616L188.675 5.42093H192.409L197.38 18.593ZM191.948 13.6916L190.531 9.49253L189.092 13.6916H191.948ZM216 18.593H212.574L206.272 10.5266V18.593H202.846V5.42093H206.272L212.574 13.4792V5.42093H216V18.593Z",
    fill: "url(#paint5_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 23.5897,
    y1: 14.3724,
    x2: 7.54425,
    y2: 10.048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 17.6657,
    y1: 28.0741,
    x2: -5.01531,
    y2: -3.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 12.0415,
    y1: 23.2865,
    x2: 22.8143,
    y2: 9.63069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 2.35356,
    y1: 13.0294,
    x2: 11.4578,
    y2: 4.38098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 21.3887,
    y1: 2,
    x2: 21.3887,
    y2: 8.10381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0895638,
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.240189,
    stopColor: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425047,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536875,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 134.504,
    y1: 29.5389,
    x2: 134.504,
    y2: -6.87891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuardarianHorizontal);
export default __webpack_public_path__ + "static/media/guardarian-horizontal.5b666fba.svg";
export { ForwardRef as ReactComponent };